import { PolicyTypeIconConstants } from '@amfam/policy/models';
import { AutomaticPayment, ScheduledPayment } from '@amfam/shared/models';

export interface BillAccountCard {
  icon: PolicyTypeIconConstants;
  policyType: string;
  alert: boolean;
  status: BillAccountCardStatus;
  metadata: BillAccountCardMetadata;
}

export interface BillAccountCardMetadata {
  billAccountNumber: string;
  billAccountNickname: string;
  minimumDue: number;
  minimumDueDate: string;
  accountBalance: string;
  hasAFT: boolean;
  hasUnsuccessfulPayment: boolean;
  isPastDue: boolean;
  hasLoadPreferencesError: boolean;
  isOnlineBilling: boolean;
  isRegisteredElseWhere: boolean;
  isReadOnly: boolean;
  hasExpiringPaymentMethod: boolean;
  hasExpiredPaymentMethod: boolean;
  expiredOrExpiringPaymentAccounts: string[];
  hasMultipleScheduledPayments: boolean;
  hasSingleScheduledPayment: boolean;
  scheduledPayments: ScheduledPayment[];
  hasAutoPay: boolean;
  hasAutoPayError: boolean;
  automaticPayments: AutomaticPayment;
  hasTPIPayer: boolean;
  hasMinimumAmountDue: boolean;
  hasPaymentDueToday: boolean;
  riskDescriptions: string[];
  isAdvance: boolean;
  lastPaymentDate: string;
  cancelLetterSent: boolean;
  previousAmountDue: number;
  policyList: string[];
  isRomeNew: boolean;
  isRomeOld: boolean;
  pillVariant: string;
  pillText: string;
  multipleScheduledPaymentsCount: number;
}

export interface BillAccountCardStatus {
  statusText: string;
  actionButton: BillAccountActionButtons;
  statusIcon: BillAccountStatusIcons;
  paymentNeeded?: boolean;
  statusPillText?: string;
  statusPillType?: BillAccountPillType;
}

export enum BillAccountStatusIcons {
  CHECK = 'icon-complete-circle',
  INFO = 'icon-info',
  ALERT = 'icon-alert'
}

export enum BillAccountActionButtons {
  VIEW_PAYMENTS = 'View payments',
  EDIT_PAYMENT = 'Edit payment',
  EDIT_AUTOPAY = 'Edit autopay',
  VIEW_ACCOUNT = 'Bill details',
  MAKE_PAYMENT = 'Pay',
  ADD_AUTOPAY = 'Set up autopay',
  EDIT_PAYMENT_ACCOUNT = 'Update card',
  EDIT_LENDER = 'Edit lender'
}

export enum BillAccountStatusText {
  MULTIPLE_SCHEDULED_PAYMENTS = 'payments scheduled',
  MULTIPLE_PROCESSING_PAYMENTS = 'payments processing',
  SCHEDULED_FOR = 'scheduled for',
  WILL_BE_PAID_ON = 'will be paid on',
  ENROLL_AUTOMATIC_PAYMENTS = 'Enrolled in AutoPay.',
  ENROLL_AFT = 'Enrolled in Automated Funds Transfer.',
  PAST_DUE = 'Account is past due',
  DUE_TODAY = 'Your payment is due today.',
  NOTHING_DUE = 'Save time by setting up autopay',
  FAILED_PAYMENT = 'Your payment was unsuccessful.',
  FAILED_PAYMENT_PASTDUE = 'Your payment was unsuccessful and this account is past due.',
  FAILED_PREFS_LOAD = 'Unable to retrieve account data. Please try again later.',
  FAILED_AUTOPAY_LOAD = 'Unable to retrieve autopay details. Please try again later.',
  // Need to check with Madhav how/where to use this text
  EXTERNAL_BAM = 'This account is managed by another policyholder',
  EXPIRED_PAYMENT_ACCOUNT = 'Please update your card info',
  EXPIRING_PAYMENT_ACCOUNT = 'Your credit/debit card is about to expire. Update your card details soon.'
}

export enum BillAccountPillType {
  WARNING = 'warning-pill',
  ERROR = 'error-pill',
  SUCCESS = 'success-pill'
}
